export default __webpack_public_path__ + "static/media/status_approved.9d54f97e.svg";